module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-5.c05e89d1.svg";